import { tick } from "../helpers/tick";
import { toggleClass, addClass, removeClass } from "../helpers/classToggler";

export const NavController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initWindowScrollListener();
        this.initMobileMenu();
        this.initMobileSubMenus();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  menuIsMobileMode() {
    return window.innerWidth < 1024;
  },

  initWindowScrollListener: () => {
    const navbar = document.querySelector(".site-nav");
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        document.documentElement.classList.add("scrolled");
      } else {
        document.documentElement.classList.remove("scrolled");
      }
    });
  },

  initMobileMenu() {
    const nav = document.querySelector(".site-nav");
    const toggle = document.querySelector(".mobile-menu-toggle");
    if (!nav || !toggle) return;

    toggle.addEventListener("click", async () => {
      toggleClass(
        document.documentElement,
        "menu-open",
        () => {
          toggle.querySelector("use").setAttribute("xlink:href", "#icon-close");
        },
        () => {
          toggle.querySelector("use").setAttribute("xlink:href", "#icon-menu");
        }
      );
      addClass(toggle, "active");
      await tick(100);
      removeClass(toggle, "active");
    });
  },

  initMobileSubMenus() {
    this.initMobileMenuTriggers();
  },

  // Uncomment to bring back click to set submenu
  initMobileMenuTriggers() {
    const els = document.querySelectorAll(".menu-item-has-children > a");

    const toggleMobileMenu = (event) => {
      event.preventDefault();
      const { target } = event;
      const { parentNode } = target;

      if (document.documentElement.classList.contains("menu-open")) {
        document.documentElement.classList.remove("menu-open");
      } else {
        document.documentElement.classList.add("menu-open");
      }
    };

    Array.from(els).forEach((el) => {
      el.addEventListener("click", toggleMobileMenu);
    });

    Array.from(els).forEach((el) => {
      el.classList.remove("menu-open");
    });
  },

  initMobileSubmenuAutoCollapse() {
    const submenuLinks = document.querySelectorAll(".sub-menu a");
    const closeParentMenu = (event) => {
      const { target } = event;
      let parentEl = target;
      while (parentEl.parentNode) {
        parentEl = parentEl.parentNode;
        if (parentEl.classList && parentEl.classList.contains("menu-open")) {
          break;
        }
      }

      parentEl.classList && parentEl.classList.remove("menu-open");
      this.toggleMobileMenu();
    };
    Array.from(submenuLinks).forEach((link) => {
      link.addEventListener("click", closeParentMenu);
    });
  },
};
